export const MODULE_NAME = 'CONFIGURATION_MODULE';
